// extracted by mini-css-extract-plugin
export default {"activedfdf":"Navbar_activedfdf__b2vR6","active":"Navbar_active__1beOI"};